module.exports = __webpack_public_path__ + "img/fusion-bg.08f41a55.png";